import React from 'react'
import Spinner from '@/ui/Spinner'

interface TableCellButtonProps {
  isDisabled?: boolean
  isLoading?: boolean
  children: React.ReactNode
  onClick: () => void
}

const TableCellButton = ({
  isDisabled,
  isLoading,
  children,
  onClick,
}: TableCellButtonProps) => {
  return (
    <button
      className="table-cell-button"
      onClick={onClick}
      disabled={isDisabled}
    >
      {isLoading ? <Spinner isVisible /> : children}
    </button>
  )
}

export default TableCellButton
